import React from 'react';

export const PricingTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'dashboard', label: 'Pricing Dashboard' },
    { id: 'variables', label: 'Price Variables' },
    { id: 'priority', label: 'Priority Variables' },
    { id: 'frequency', label: 'Frequency' },
  ];

  return (
    <div className="d-flex bg-light rounded-top" style={{ backgroundColor: '#f4f4f4' }}>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`py-3 px-4 cursor-pointer font-weight-bold`}
          style={{
            cursor: 'pointer',
            fontSize: '14px',
            color: activeTab === tab.id ? '#000' : '#888',
            borderBottom: activeTab === tab.id ? '3px solid #000' : 'none',
            transition: 'all 0.2s ease',
          }}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </div>
      ))}
      <div className="flex-grow-1 border-bottom" style={{ borderBottom: '1px solid #dee2e6' }}></div>
    </div>
  );
};

export const PrioritySubTabs = ({ activeSubTab, onSubTabChange }) => {
  const subTabs = [
    { id: 'brand', label: 'Brand Priority' },
    { id: 'category', label: 'Category Priority' },
    { id: 'price', label: 'Price Priority' },
    { id: 'sale', label: 'Sale Priority' },
  ];

  return (
    <div className="d-flex bg-light border-bottom mb-3" style={{ backgroundColor: '#f4f4f4', }}>
      {subTabs.map((tab) => (
        <div
          key={tab.id}
          className={`py-2 px-4 cursor-pointer font-weight-bold`}
          style={{
            cursor: 'pointer',
            fontSize: '13px',
            color: activeSubTab === tab.id ? '#000' : '#888',
            borderBottom: activeSubTab === tab.id ? '2px solid #000' : 'none',
            transition: 'all 0.2s ease',
            whiteSpace: 'nowrap'
          }}
          onClick={() => onSubTabChange(tab.id)}
        >
          {tab.label}
        </div>
      ))}
      <div className="flex-grow-1 border-bottom" style={{ borderBottom: '1px solid #dee2e6' }}></div>
    </div>
  );
};

export const SearchBar = ({ value, onChange, placeholder = "Search..." }) => (
    <div className="mb-3">
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ maxWidth: '300px', fontSize: '14px' }}
      />
    </div>
  );
  
  export const Pagination = ({ currentPage, totalItems, pageSize = 20, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / pageSize);
    
    if (totalPages <= 1) return null;
  
    // Logic to show limited page numbers if totalPages is large
    // For simplicity, showing all or a simple slice could be used. 
    // Implementing a basic safe slice for now (start, current-1, current, current+1, end)
  
    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5;
        
        if (totalPages <= maxPagesToShow) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
             // Always show first
             pages.push(1);
             
             let start = Math.max(2, currentPage - 1);
             let end = Math.min(totalPages - 1, currentPage + 1);
  
             if (start > 2) pages.push('...');
             for (let i = start; i <= end; i++) pages.push(i);
             if (end < totalPages - 1) pages.push('...');
             
             // Always show last
             pages.push(totalPages);
        }
        return pages;
    };
  
    const pages = getPageNumbers();
  
    return (
      <nav className="d-flex justify-content-end mt-3">
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button 
              className="page-link" 
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
          </li>
          
          {pages.map((page, idx) => (
             <li key={idx} className={`page-item ${page === currentPage ? 'active' : ''} ${page === '...' ? 'disabled' : ''}`}>
               {page === '...' ? (
                   <span className="page-link">...</span>
               ) : (
                  <button 
                     className="page-link" 
                     onClick={() => onPageChange(page)}
                  >
                    {page}
                  </button>
               )}
            </li>
          ))}
  
           <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button 
              className="page-link" 
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };
